import React, { Component } from 'react';
import { Gift, FolderOpen, FileText, AlertTriangle } from 'lucide-react';
import { Button } from '../ui/Button';
export function BonusesSection() {
  const bonuses = [{
    title: 'Paquete de recursos',
    description: 'Gráficos, videos de stock, sonidos y transiciones listas para usar en tus proyectos.',
    value: '$135.000',
    icon: FolderOpen,
    image: 'https://cdn.magicpatterns.com/uploads/aoH2oD7QRJZNz71dno2wFF/5736x0.webp'
  }, {
    title: 'Plantilla de Portfolio',
    description: 'La estructura exacta para armar un portfolio que convierte visitas en clientes reales.',
    value: '$105.000',
    icon: FileText,
    image: 'https://cdn.magicpatterns.com/uploads/5y9Qrj4tvaYVcZhjHhuZvG/Captura_de_pantalla_2026-03-08_230834.png'
  }, {
    title: 'Lista de Nichos Rentables',
    description: 'Los nichos más rentables para empezar a vender tus servicios de edición desde el día 1, con ejemplos reales y estrategias para cada uno.',
    value: '$75.000',
    icon: AlertTriangle,
    image: 'https://cdn.magicpatterns.com/uploads/ud3wLH42dJCWjS4zUrcSkY/1.webp'
  }];
  return <section className="py-16 md:py-24 bg-slate-900 px-4" data-id="element-20">
      <div className="max-w-5xl mx-auto" data-id="element-21">
        <div className="text-center mb-16" data-id="element-22">
          <div className="inline-flex items-center justify-center p-3 bg-blue-500/20 text-blue-400 rounded-full mb-4" data-id="element-23">
            <Gift className="w-6 h-6" data-id="element-24" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-25">
            Bonos de regalo (solo hoy)
          </h2>
          <p className="text-slate-400 mt-4 text-lg" data-id="element-26">
            Llevate todo esto GRATIS al ingresar hoy al curso.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-27">
          {bonuses.map((bonus, index) => {
          const IconComponent = bonus.icon;
          return <div key={index} className="bg-slate-800 border border-slate-700 rounded-2xl overflow-hidden relative group hover:border-blue-500/50 transition-colors flex flex-col" data-id="element-28">
                <div className="absolute top-3 right-3 bg-blue-600 text-white text-xs font-bold px-3 py-1 rounded-full z-10" data-id="element-29">
                  BONO {index + 1}
                </div>

                {/* Illustrative image */}
                <div className="relative w-full h-40 overflow-hidden" data-id="element-30">
                  <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover opacity-60 group-hover:opacity-80 transition-opacity duration-300" data-id="element-31" />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-800 to-transparent" data-id="element-32" />
                  <div className="absolute bottom-4 left-4" data-id="element-33">
                    <div className="w-10 h-10 bg-blue-600/30 backdrop-blur-sm rounded-lg flex items-center justify-center" data-id="element-34">
                      <IconComponent className="w-5 h-5 text-blue-400" data-id="element-35" />
                    </div>
                  </div>
                </div>

                <div className="p-6 flex flex-col flex-grow" data-id="element-36">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-37">
                    {bonus.title}
                  </h3>
                  <p className="text-slate-400 mb-6 text-sm leading-relaxed flex-grow" data-id="element-38">
                    {bonus.description}
                  </p>

                  <div className="pt-4 border-t border-slate-700" data-id="element-39">
                    <div className="flex justify-between items-center" data-id="element-40">
                      <span className="text-slate-500 line-through text-sm" data-id="element-41">
                        Valor: {bonus.value} ARS
                      </span>
                      <span className="text-green-400 font-bold" data-id="element-42">
                        Hoy: GRATIS
                      </span>
                    </div>
                  </div>
                </div>
              </div>;
        })}
        </div>

        <div className="text-center" data-id="element-43">
          <Button href="https://brunocairo.com/cart/50636149457129:1" size="xl" isExternal className="w-full md:w-auto md:px-12" data-id="element-44">
            Quiero el curso + los bonos gratis
          </Button>
        </div>
      </div>
    </section>;
}